var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-to-mail",class:{ disabled: _vm.disabled, 'is-deleted': _vm.isDeleted },attrs:{"title":_vm.disabled ? _vm.title : ''},on:{"click":_vm.handleClick}},[_vm._v("添加到待邮寄")])}
var staticRenderFns = []

export { render, staticRenderFns }